import { render, staticRenderFns } from "./wizards.vue?vue&type=template&id=37064a7f&"
import script from "./wizards.vue?vue&type=script&lang=js&"
export * from "./wizards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports